
            // TRIP-28386: Spacesuit Helpcenter uses window.getActiveDocumentationComponent from the monolith.
            window.getActiveDocumentationComponent = () => {
                return '249';
            };

            // TRIP-28085 & TRIP-27837: Remove this when the LegacySessionExpiredDialog killswitch is removed from the monolith
            window.legacySessionExpiredDialogEnabled = false;
        